<span class="avatar-component">
  <img
    src="assets/images/role-avatars/ICON_{{ getDominantRole() }}.png"
    alt="{{ getDominantRole() }}"
  />
</span>
